import { createSelector } from 'reselect';

import { ALLOW_NEARBY_IS_ACTIVE_DEFAULT } from '../constants';
import { selectRawFilterData } from './general';

function _selectAllowNearby(state, filterId) {
    return selectRawFilterData(state, filterId).allowNearby;
}

const selectAllowNearbyFilterData = createSelector(
    _selectAllowNearby,
    (isActive) => ({ isActive }),
);

function _isAllowNearbyFiltered(isActive) {
    return isActive !== ALLOW_NEARBY_IS_ACTIVE_DEFAULT;
}

const selectAllowNearbyIsFiltered = createSelector(
    _selectAllowNearby,
    _isAllowNearbyFiltered,
);

export {
    selectAllowNearbyFilterData,
    selectAllowNearbyIsFiltered,
};
